import {updateToken, useGetAuthToken} from "../store/api/AuthSlice";
import {useAuth0} from "@auth0/auth0-react";
import {useDispatch} from "../store/Store";
import {useEffect, useState} from "react";

export const useGetAndFetchToken = () => {
    const token = useGetAuthToken()
    const {getAccessTokenSilently, user} = useAuth0()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        // Token authorization
        getAccessTokenSilently({detailedResponse: true}).then(r => {
            setLoading(true)
            dispatch(updateToken(r.access_token))
            setLoading(false)
        })
    }, [dispatch, getAccessTokenSilently])

    return {loading, token, user}
}